const svgs = {
	straight: {
		d: "M 3 25 V 7 H 0 L 5.5 0 L 11 7 H 8 V 25 H 3",
		height: 25,
		width: 11,
		transform: 0
	},
	left: {
		d:
			"M 15 25 V 9 Q 15 3, 9 3 H 7 V 0 L 0 5 L 8 11 V 8 H 9 Q 10 8, 10 9 V 25 H 15",
		height: 25,
		width: 16,
		transform: -4
	},
	right: {
		d:
			"M 0 25 V 9 Q 0 3, 6 3 H 8 V 0 L 15 5 L 8 11 V 8 H 6 Q 5 8, 5 9 V 25 H 0",
		height: 25,
		width: 16,
		transform: 4
	}
};

export default class Maneuver {
	leftTurnIds = [1, 4];
	rightTurnIds = [2, 4];
	straightThruIds = [0];

	maneuverId;

	constructor(maneuverId) {
		this.maneuverId = maneuverId;
	}

	/**
	 * Returns the svg for the maneuverId.
	 */
	get svg() {
		switch (this.maneuverType) {
			case "left":
				return svgs.left;
			case "right":
				return svgs.right;
			case "thru":
				return svgs.straight;
			default:
				return "";
		}
	}

	get maneuverType() {
		switch (true) {
			case this.leftTurnIds.indexOf(this.maneuverId) > -1:
				return "left";
			case this.rightTurnIds.indexOf(this.maneuverId) > -1:
				return "right";
			case this.straightThruIds.indexOf(this.maneuverId) > -1:
				return "thru";
			default:
				return "";
		}
	}

	/**
	 * Essentially this an index that you can sort by, going from
	 * smallest to largest, will place the maneuver in left, thru or right
	 * positions.
	 */
	get placement() {
		switch (this.maneuverType) {
			case "left":
				return 0;
			case "right":
				return 1;
			case "thru":
				return 2;
			default:
				return -1;
		}
	}
}
